<template>
  <div class="goods-list-template" theme>
    <div id="theme-goods-list-header" />
    <div id="theme-goods-list-leftside" />
    <div id="theme-goods-list-content" />
    <div id="theme-goods-list-rightside" />
    <div id="theme-goods-list-footer" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'goods-list',
      parts: [
        {
          elem: '#theme-goods-list-header',
          htmlFile: 'header'
        },
        {
          elem: '#theme-goods-list-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#theme-goods-list-content',
          htmlFile: 'content'
        },
        {
          elem: '#theme-goods-list-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#theme-goods-list-footer',
          htmlFile: 'footer'
        }
      ]
    }
  }
}
</script>

<style scoped>
.goods-list-template {
  min-height: 100px;
  margin-top: -35px;
}
</style>
